// extracted by mini-css-extract-plugin
export default {"wrap":"ErrorBoundedHomepage_wrap__qXDdn","progress-bar":"ErrorBoundedHomepage_progress-bar__vWx2g","loading-dots-container":"ErrorBoundedHomepage_loading-dots-container__DRusN"};